import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { app, facebookProvider, database } from '../config/base'
import pdf from './reglement.pdf'
import welcomeImg from '../assets/img/welcome.png'
import fbicon from '../assets/img/fbicon.png'
import Alert from './Alert';
import imgComment from '../assets/img/comment.png'
const whiteDot = {
  color: "white"
}

class Login extends Component {
  constructor(props) {
    super(props)
    this.authWithFacebook = this.authWithFacebook.bind(this)
    this.authWithEmailPassword = this.authWithEmailPassword.bind(this)
    this.openMecanismeMenu= this.openMecanismeMenu.bind(this)
    this.hideCommentScreen = this.hideCommentScreen.bind(this)
    this.state = {
      redirect: false,
      AlertModalMessage:'Try alternative login',
      AlertModalType:'warning',
      AlertIsHidden:true,
      activeMenuIsAcceuil:true,
      activeMenuIsMecanisme:false
    }
  }


  openMecanismeMenu()
  {
    this.setState({
      activeMenuIsMecanisme:true,
      activeMenuIsAcceuil:false
    })
  }
  hideCommentScreen()
  {
    this.setState({
      activeMenuIsMecanisme:false,
      activeMenuIsAcceuil:true
    })
  }

  resetAlertStatus()
  {
    var _this = this;
    setTimeout(function(){
        _this.setState({
          AlertIsHidden:true
        })
    }, 3000);
  }
  authWithFacebook() {
    app.auth().signInWithPopup(facebookProvider)
      .then((user, error) => {
        if (error) {
          //this.toaster.show({ intent: Intent.DANGER, message: "Unable to sign in with Facebook" })
          this.setState({
            AlertModalMessage:'Unable to sign in with Facebook',
            AlertModalType:'danger',
            AlertIsHidden:false
          }, () => this.resetAlertStatus())

        } else {
          this.props.setCurrentUser(user)
          this.addUser(user.user)
          console.log(user.user)
          this.setState({ redirect: true })
        }
      })
  }

  addUser(user){

    var url='users/'+user.uid

    database.ref(url).set({
        username: user.displayName,
        email: user.email
      });
      console.log("done")
  }




  authWithEmailPassword(event) {
    event.preventDefault()
    const email = this.emailInput.value
    const password = this.passwordInput.value

    app.auth().fetchProvidersForEmail(email)
      .then((providers) => {
        if (providers.length === 0) {
          // create user
          return app.auth().createUserWithEmailAndPassword(email, password)
        } else if (providers.indexOf("password") === -1) {
          // they used facebook
          this.loginForm.reset()

          this.setState({
            AlertModalMessage:'Try alternative login',
            AlertModalType:'warning',
            AlertIsHidden:false
          }, () => this.resetAlertStatus())

        } else {
          // sign user in
          return app.auth().signInWithEmailAndPassword(email, password)
        }
      })
      .then((user) => {
        if (user && user.email) {
          this.loginForm.reset()
          this.props.setCurrentUser(user)
            this.addUser(user)

            console.log(user)
          this.setState({redirect: true})

        }
      })
      .catch((error) => {
        this.setState({
          AlertModalMessage:error.message,
          AlertModalType:'danger',
          AlertIsHidden:false
        }, () => this.resetAlertStatus())
      })
  }

  render() {
    var activeMenuIsAcceuil=""
    var activeMenuIsMecanisme=""
    if(this.state.activeMenuIsAcceuil===true)
        activeMenuIsAcceuil=""
    else
      activeMenuIsAcceuil="hiddenOpacity"

    if (this.state.activeMenuIsMecanisme===true)
        activeMenuIsMecanisme=""
    else
        activeMenuIsMecanisme="hiddenOpacity"
  //  const { from } = this.props.location.state || { from: { pathname: '/' } }   <Alert message={this.state.AlertModalMessage} AlertIsHidden={this.state.AlertIsHidden} AlertModalType={this.state.AlertModalType}/>
// <img src={btnFb} alt="btnFb" className="btnFbimg" onClick={() => { this.authWithFacebook() }}/>
    if (this.state.redirect === true) {
      return <Redirect  to='/signup' />
    }

    return (
      <div >
        <div className="commentScreen">
          <img  src={imgComment} onClick={this.hideCommentScreen} className="commentScreenImg" hidden={!this.state.activeMenuIsMecanisme} alt=""/>
        </div>

        <img src={welcomeImg} alt="" className="imgWelcome"/>

        <div className="MenuWelcome">
          <div className="containerBoxBtns">
            <a className="menuLink"><span className={"dot "+activeMenuIsAcceuil}></span>ACCEUIL</a>
            <a className="menuLink" onClick={this.openMecanismeMenu}><span className={"dot "+activeMenuIsMecanisme}></span>MÉCANISME</a>
            <a className="menuLink" target="_blank" href={pdf}><span style={whiteDot}></span>RÈGLEMENT</a>
          </div>
          <button onClick={() => { this.authWithFacebook() }} className="btnFb2">COMMENCEZ<img src={fbicon} alt="fb icon"/></button>
        </div>
        <p className="x9a9a9a">Connexion Facebook requise</p>

      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login.js